<template>
  <div class="all-read-wrapper">
    <p @click="confirm">すべて既読にする</p>
  </div>
</template>

<script>
import toastr from '@v2/atoms/clinic/WideToastr.vue';
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('questionnaire');

export default {
  name: 'AllRead',
  props: {
    selectedReceptionItemId: {
      type: Number,
      required: true,
    },
    unreadIds: {
      type: Array,
      required: true,
    },
  },
  created() {
    this.updateUnreadIds(this.unreadIds);
  },
  methods: {
    ...mapActions(['updateQuestionnaireRead', 'fetchQuestionnaireUnreadCount', 'fetchQuestionnaireUnreadCountCacheClear', 'updateUnreadIds']),
    confirm() {
      this.$swal({
        title: 'すべて既読にする',
        text: `現在表示中の受付項目がすべて既読になります。
        本当にすべて既読にしますか？`,
        icon: 'warning',
        className: 'questionnaires-all-read',
        closeOnClickOutside: false,
        buttons: ['キャンセル', 'OK'],
        dangerMode: true,
      }).then(async (isOK) => {
        if (!isOK) return;

        await this.updateQuestionnaireRead(this.selectedReceptionItemId)
          .then(async () => {
            await this.fetchQuestionnaireUnreadCount(this.selectedReceptionItemId);
            await this.fetchQuestionnaireUnreadCountCacheClear();
            toastr.success('現在表示中の受付項目がすべて既読になりました。');
          })
          .catch(() => toastr.error('既読処理に失敗しました。'));
      });
    },
  },
};
</script>

<style lang="sass">
.all-read-wrapper
  position: absolute
  top: 0
  right: 140px
  font: $font-sub
  color: $color-text-description
  text-decoration: underline
  cursor: pointer

  > p
    margin: 0

.questionnaires-all-read > .swal-text
  text-align: center
</style>
